import Router from 'next/router';

import ROUTES from 'Utilities/routes';

export const getClientSideHomePageRedirect = async (): Promise<void> => {
	await Router.push(ROUTES.INDEX.href);
};
